module.exports = __webpack_public_path__ + "img/MTABAPPFEV6.22645e8b.jpg";